export const getYupFieldMaxValue = (schema: any, fieldName: string) => {
    const field = schema.describe().fields[fieldName];
    const maxText = field.tests.find((test) => test.name === 'max');
    const {
        params: { max },
    } = maxText;
    return max || Infinity;
};
